export const FEATURED_RACKET_SKUS = ["PC-STA-RAC-71I7", "PC-STA-RAC-I4Z9"] as const;

export type FeaturedRacketTheme = "gold" | "wine";

const FEATURED_RACKET_THEME_BY_SKU: Record<string, FeaturedRacketTheme> = {
  "PC-STA-RAC-71I7": "gold",
  "PC-STA-RAC-I4Z9": "wine",
};

export function getFeaturedRacketTheme(sku?: string): FeaturedRacketTheme | null {
  if (!sku) return null;
  return FEATURED_RACKET_THEME_BY_SKU[sku.trim().toUpperCase()] ?? null;
}

export function featuredRacketRank(sku?: string): number {
  if (!sku) return FEATURED_RACKET_SKUS.length;
  const index = FEATURED_RACKET_SKUS.indexOf(sku.trim().toUpperCase() as typeof FEATURED_RACKET_SKUS[number]);
  return index === -1 ? FEATURED_RACKET_SKUS.length : index;
}